import { UserDataService } from 'src/app/core/services/user/userData.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { concatMap, of, switchMap, tap } from 'rxjs';
import {
  getFase,
  getIsOperativeAffiliate,
} from 'src/app/core/extensions/status.extensions';
import { SEOService } from 'src/app/core/services/SEO/seoservice.service';
import { AffiliateService } from 'src/app/core/services/affiliate/affiliate.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { environment } from 'src/environments/environment';
import { ChildrenService } from 'src/app/core/services/affiliate/children.service';

@Component({
  selector: 'app-login-admin',
  templateUrl: './login-admin.component.html',
  styleUrls: ['./login-admin.component.scss'],
  standalone: false,
})
export class LoginAdminComponent implements OnInit {
  _userId: string;
  _token: any;
  public userType: string;
  public affiliatePath: string[];
  public creditList: any[];
  public activeCredit: any;
  public activeCreditList: any[];

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private affiliateService: AffiliateService,
    private seoService: SEOService,
    private userDataService: UserDataService,
    private childrenService: ChildrenService
  ) { }

  ngOnInit(): void {
    /* this.spinnerService.showLoading(); */
    this.route.paramMap.subscribe((params) => {
      this._userId = params.get('id');
      this._token = params.get('token');
      sessionStorage.setItem('token', this._token);
    });

    this.auth.getTokenFromAdmin(this._userId).subscribe(
      (res) => {
        this.setSession(res.token);
        this.userData();
      },
      (err) => {
        let alertStatus = 'expired';
        if (err.error?.code === 401) {
          alertStatus = 'expired';
        } else {
          alertStatus = 'ko';
        }
        sessionStorage.removeItem('token');
        this.router.navigate(['/login'], {
          queryParams: {
            alertStatus,
          },
        });
      }
    );
  }
  userData() {
    let userType;
    this.userDataService.setUserType('');
    this.userDataService.setNameSession('');
    this.userService
      .getUser(this._userId)
      .pipe(
        concatMap((res) => {
          const userData = res;
          sessionStorage.setItem('userType', res.tipo);
          this.userDataService.setUserType(res.tipo);
          sessionStorage.setItem('userId', this._userId);
          sessionStorage.setItem('userName', res.firstname);
          sessionStorage.setItem('email', userData.email);
          userType = sessionStorage.getItem('userType');
          if (userType === 'prestatario') {
            this.userDataService.setNameSession(userData.firstname);
            if (userData.afiliado) {
              sessionStorage.setItem(
                'affiliateId',
                this.getIdFromPath(userData.afiliado)
              );
              return this.userService.getCreditList(this._userId);
            } else {
              this.router.navigate(['/prestatario/inactivo']);
              return of(null);
            }
          } else {
            if (userType === 'comercial') {
              sessionStorage.setItem('sagent', userData.username)
            }
            sessionStorage.setItem(
              'affiliateId',
              this.getIdFromPath(userData.afiliado)
            );
            return of(null);
          }
        }),
        concatMap((creditList) => {
          if (creditList) {
            this.creditList = creditList['hydra:member'];
            const activePhases = ['FA', 'FS', 'FF', 'FE'];
            const activeStatus = ['EAM', 'RET', 'FAL'];
            /*    this.activeCredit = this.creditList.find(item => activePhases.includes(getFase(item.estadoCd))); */

            //!listado de créditos ACTIVOS (preguntar si tienen que ser activos o cualquiera)

          this.activeCreditList = this.creditList.filter(item => activePhases.includes(getFase(item.estadoCd)) || activeStatus.includes(item.estadoCd));
        }
        return this.affiliateService.getAffiliate(sessionStorage.getItem('affiliateId'))
      })
    ).subscribe((data) => {
      sessionStorage.setItem('financedRate', data.financedRate)
      sessionStorage.setItem('formacionAsnef', data.formacionAsnef)
      sessionStorage.setItem('primaryReason', data.primaryReason)
      const businessId = this.getIdFromPath(data!.datosEmpresa)
      if (data.estadoCd === 'VIR') {
       this.childrenService.setAffiliateVirState(true)
      }
      const linksEnabled = {
        inversores: data.usuarios,
        links: data.links,
        simulador: (data.estadoCd !== 'NAC' && data.estadoCd !== 'RSK' && data.estadoCd !== 'VIR') ? data.simulador : false,
        cobros: data.cobrosEnabled,
        reports: data.reports,
        usuarios: data.usuarios,
      }
      this.affiliateService.getAffiliateBasicInfo(sessionStorage.getItem('affiliateId')).pipe(
        tap((res) => {
          linksEnabled['transfers'] = res.transactionsEnabled;
          if (userType === 'comercial') {
            linksEnabled.inversores = false;
            linksEnabled.links = false;
            linksEnabled.cobros = false;
            linksEnabled.reports = false;
            linksEnabled.usuarios = false;
            linksEnabled['transfers'] = false;
          }
          sessionStorage.setItem('linksEnabled', JSON.stringify(linksEnabled))
          /* if(sessionStorage.getItem('userType') === 'afiliado') {
            this.setAffiliateLinks()
          } */
        
          const currentPath = environment.baseUrl
          this.userDataService.setLogoSession(currentPath + '/logos/' + res.logo)
        })
      ).subscribe((fin) => {
        if (userType != 'prestatario') {
          this.userDataService.setNameSession(data.nombre)
        }

              sessionStorage.setItem(
                'businessId',
                this.getIdFromPath(data.datosEmpresa)
              );
              sessionStorage.setItem('estadoCd', data.estadoCd);
              sessionStorage.setItem('showSalesComission', data.showSalesComission);
              sessionStorage.setItem('delivery', data.immediateDelivery);
              sessionStorage.setItem('coefficient', data.showCoefficient);
              sessionStorage.setItem('corporationName', data.nombre);
              sessionStorage.setItem('datosEmpresa', data.datosEmpresa);
              sessionStorage.setItem(
                'associatedInvestor',
                this.getIdFromPath(data.associatedInvestor)
              );
              sessionStorage.setItem(
                'salesAgentId',
                this.getIdFromPath(data.zankSalesAgent)
              );
              if (userType == 'prestatario') {
                if (this.activeCreditList.length === 1) {
                  this.router.navigate(['/prestatario'], {
                    queryParams: { id: this.activeCreditList[0].id },
                  });
                } else if (this.activeCreditList.length > 1) {
                  sessionStorage.setItem('multipleCredits', 'true');
                  this.router.navigate(['/prestatario']);
                } else if (this.activeCreditList.length === 0) {
                  this.router.navigate(['/prestatario/inactivo']);
                }
              } else {
                this.router.navigate(['/afiliado']);
              }
            });
        },
        (err) => {
          /* console.log(err) */
        }
      );
  }

  setSession(token: string) {
    if (token != '') this.auth.setSessionLogged(token);
  }
  public getIdFromPath(path: string): string {
    const segments = path?.split('/');
    return segments?.[segments.length - 1];
  }

  logout() {
    return this.auth.logout();
  }
}
